<template>
  <div class="record-wrap" v-loading="loading">
    <div class="company-list">
      <div @click="handleCompany(item)" v-for="(item, index) in corpList" :key="index"
        :class="detailInfo.activeCorp == item.corpId ? 'tag-company active-tag-company' : 'tag-company'">
        {{ item.corpName }}
      </div>
    </div>

    <div class="recprd-list-wrap">
      <el-tabs v-model="detailInfo.activeName" @tab-click="handleClick">
        <el-tab-pane label="连连" name="LianLian" v-if="lianLianAccountStatus.open">
          <LianTransDetail :detailInfo="detailInfo" :supplierId="supplierId" :trxOptions="LianLianTrxOptions"
            ref="LianLianDetail"></LianTransDetail>
        </el-tab-pane>
        <el-tab-pane label="锐锢" name="RuiGu">
          <RuiGuTransDetail :detailInfo="detailInfo" ref="RuiGuDetail"></RuiGuTransDetail>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import LianTransDetail from "./components/LianTransDetail";
import RuiGuTransDetail from "./components/RuiGuTransDetail";
import { getCompanyList, checkLian, getTransactionType } from "@/models/purseSet";
export default {
  components: { LianTransDetail, RuiGuTransDetail },
  data() {
    return {
      corpList: [],
      supplierId: "",
      detailInfo: {
        activeCorp: "", // 选中公司
        activeName: "RuiGu",
      },
      LianLianTrxOptions: [],   // 连连交易类型枚举
      lianLianAccountStatus: {}, // 连连账户状态信息 是否开户 open 是否激活 activation
      loading: false,
      timer: null
    };
  },
  created() {
    this.supplierId = window.localStorage.getItem("supplier_id");
    this.initCompanyList();
  },
  methods: {
    // 初始化公司列表
    initCompanyList() {
      this.loading = true;
      const params = {
        supplierId: this.supplierId,
      };
      getCompanyList(params)
        .then((res) => {
          this.loading = false;
          if (res.data) {
            if (res.data.length > 0) {
              // 过滤出有钱袋显示的公司 show == 1
              this.corpList = res.data.filter(item => item.show === 1);
              this.detailInfo.activeCorp = this.corpList[0].corpId;
              // 默认初始化第一个公司连连钱袋的账户状态信息 若未开户 则不显示连连交易明细
              this.handleCompany(this.corpList[0]);
              // 初始化连连交易类型枚举值
              this.initTransactionEnum(2);
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },

    // 初始化交易类型枚举值
    initTransactionEnum(type) {
      getTransactionType({
        purchaseChannel: 4,
        purseType: type
      }).then(res => {
        if (type == 2) this.LianLianTrxOptions = res.data;
      }).catch(error => {
        this.$message.error(error.message);
      })
    },

    // 切换公司
    async handleCompany(item) {
      this.detailInfo.activeCorp = item.corpId;
      try {
        // 获取选中公司 连连钱袋的账户状态信息 若未开户 则不显示连连交易明细
        const params = {
          corpId: this.detailInfo.activeCorp,
        };
        const res = await checkLian(params);
        this.lianLianAccountStatus = res.data;

        // 若连连开户 默认tab 连连 否则 默认tab 锐锢
        if (res.data.open) {
          this.detailInfo.activeName = 'LianLian';
        } else {
          this.detailInfo.activeName = 'RuiGu';
        }

        if (this.detailInfo.activeName == 'RuiGu') {
          // 初始化锐锢交易明细列表
          this.$refs.RuiGuDetail.initData();
        } else if (this.detailInfo.activeName == 'LianLian') {
          this.timer = setTimeout(() => {
            // 初始化连连交易明细列表
            this.$refs.LianLianDetail.initData();
          }, 200)
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    // 切换 锐锢 连连
    handleClick(tab, event) {
      // 调用交易明细获取列表数据的方法
      if (this.detailInfo.activeName == 'RuiGu') {
        this.$refs.RuiGuDetail.initData();
      } else if (this.detailInfo.activeName == 'LianLian') {
        this.$refs.LianLianDetail.initData();
      }
    },
  },

  //生命周期 destroyed销毁定时器
  destroyed() {
    clearTimeout(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="scss">
.record-wrap {
  padding: 20px 10px;

  .company-list {
    display: flex;
    font-size: 14px;
    font-weight: 600;

    .tag-company {
      padding: 8px 16px;
      background: rgba(0, 0, 0, 0.02);
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 8px;
      cursor: pointer;
    }

    .active-tag-company {
      color: #ff6224;
    }
  }

  .recprd-list-wrap {
    margin-top: 20px;

    .el-tabs__item {
      &.is-active {
        color: #ff6224;
      }

      &:hover {
        color: #ff6224;
      }
    }

    .el-tabs__active-bar {
      background-color: #ff6224;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/record/record.vue